import { Component, inject, input } from '@angular/core';
import { AsyncPipe, NgClass } from '@angular/common';
import { RouterModule } from '@angular/router';
import {
  ExtendedAuthService,
  IsAdminPipe,
  IsExternalPipe,
  IsMonitorPipe,
} from '../../../auth/auth.service';
import { NavMenuComponent } from '../menus/menu/menu.component';
import { NavMenuLinkComponent } from '../menus/menu-link/menu-link.component';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { NavMenuAccordionComponent } from '../menus/menu-accordion/menu-accordion.component';
import { MatButtonModule } from '@angular/material/button';
import { ShoppingCartIconComponent } from '../shopping-cart-icon/shopping-cart-icon.component';
import { FilterOperator } from '../../../../api/api.operators';
import { getParamsForFilters } from '../../../filters/filter.interfaces';
import { isSystemAdministrator } from '../../../auth/role.guard';
import { GhostingComponent } from '../../../auth/ghosting/ghosting.component';
import { i18nRouterLinkDirective } from '../../../router/i18n-router-link.directive';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  standalone: true,
  imports: [
    NavMenuComponent,
    NavMenuAccordionComponent,
    NavMenuLinkComponent,
    NgClass,
    AsyncPipe,
    RouterModule,
    CdkAccordionModule,
    MatButtonModule,
    ShoppingCartIconComponent,
    IsMonitorPipe,
    IsExternalPipe,
    IsAdminPipe,
    GhostingComponent,
    i18nRouterLinkDirective,
  ],
})
export class NavigationComponent {
  public isAtTop = input<boolean>(false);

  opened = false;
  profileText = $localize`Profile`;

  protected readonly auth = inject(ExtendedAuthService);

  campsOvernightFilterParams = getParamsForFilters({
    'camp.sleepover': [FilterOperator.EQ, 1],
  });

  campsNoOvernightFilterParams = getParamsForFilters({
    'camp.sleepover': [FilterOperator.EQ, 0],
  });

  campsTeenFilterParams = getParamsForFilters({
    minAge: [FilterOperator.GTE, 12],
    maxAge: [FilterOperator.LTE, 18],
  });

  constructor() {
    // fixme: Temp fix for log out button translation on skillz4schools
    $localize` Log out `;
  }

  toggleMobileNav() {
    this.opened = !this.opened;
  }

  protected readonly isSystemAdministrator = isSystemAdministrator;
}
